<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
    
    <!-- 一键拨打电话悬浮按钮 -->
    <div class="call-float-btn" @click="makeCall">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
      </svg>
      <span>0532-66727975</span>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    makeCall() {
      const phoneNumber = '0532-66727975';
      window.location.href = `tel:${phoneNumber}`;
    }
  }
}
</script>

<style lang="scss">
// #app {
//   font-family: Avenir, Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
// }

// nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }

// 一键拨打电话悬浮按钮样式
.call-float-btn {
  position: fixed;
  right: 2rem;
  bottom: 8rem;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem 1.5rem;
  background: linear-gradient(135deg, #1a97e9, #067bd8);
  color: #fff;
  border-radius: 50px;
  box-shadow: 0 4px 20px rgba(26, 151, 233, 0.4);
  cursor: pointer;
  z-index: 9999;
  transition: all 0.3s ease;
  font-size: 1.1rem;
  font-weight: 500;

  svg {
    width: 24px;
    height: 24px;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 25px rgba(26, 151, 233, 0.5);
    background: linear-gradient(135deg, #1e9eef, #0a53a1);
  }

  &:active {
    transform: translateY(-1px);
  }

  @media (max-width: 768px) {
    right: 1rem;
    bottom: 6rem;
    padding: 0.6rem 1rem;
    font-size: 0.9rem;
    gap: 0.5rem;

    svg {
      width: 20px;
      height: 20px;
    }
  }

  @media (max-width: 480px) {
    right: 0.8rem;
    bottom: 5rem;
    padding: 0.5rem 0.8rem;
    font-size: 0.8rem;
    gap: 0.4rem;

    svg {
      width: 18px;
      height: 18px;
    }
  }
}
</style>

